export default "__VITE_ASSET__185c80b8__"